import { render, staticRenderFns } from "./Roll20Instructions.vue?vue&type=template&id=a994b8c0&lang=pug&"
import script from "./Roll20Instructions.vue?vue&type=script&lang=ts&"
export * from "./Roll20Instructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports